import "./header.css"
import logo from "../../assets/logo.jpg"
import Menu from "./menu/menu";

export default function Header () {

    return (
        <span className="Header">
            <span className="header-left-side">
                <img src={logo} className="header-logo" alt=""/>
                <p className="title">Приволжская федерация иппотерапии и адаптивного конного спорта</p>
            </span>
            
            
            <span className="header-right-side">
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSc3T-DaJYBPqS_aYls3Ol5I_yLzPPI3tP8S8r6dOIw2vhFE5w/viewform?usp=sf_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Заявка на вступление в Ассоциацию по развитию методов реабилитации лиц с ОВЗ"
                >
                    <button className="header-button">Присоединиться</button>
                </a>
                <Menu/>
            </span>
        </span>
    )
}